import { render, staticRenderFns } from "./numberWordsProDes.vue?vue&type=template&id=68605c52"
import script from "./numberWordsProDes.vue?vue&type=script&lang=js"
export * from "./numberWordsProDes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports